<div class="generalPage">
  <div class="pr-22 print-all-content content-container">
    <div class="top-heading content-blue" tabindex="0">{{about_header}}</div>
    <div class="answer font-16 content-blue width-100" id="about_content" [innerHTML]="about_content" tabindex="0"></div>
    <article class="bold font-14" (click)="openLinkById($event, true)" [innerHTML]="about_clickHere" (contextmenu)="openLinkById($event, true)"  tabindex="0"></article>
    <div class="topic-heading font-20 content-blue" tabindex="0">{{about_compatibilityHeader}}</div>
    <div class="answer font-16 content-blue width-100" [innerHTML]="about_browsers" tabindex="0"></div>
    <div class="answer font-16 content-blue width-100" id="about_otherApplications" [innerHTML]="about_otherApplications" tabindex="0"></div>
  </div>
</div>
